/**
 * Street Icon Component
 */

interface StreetIconProps {
  readonly className?: string
}

export default function StreetIcon({ className = 'h-5 w-5' }: StreetIconProps) {
  return (
    <svg
      className={className}
      fill='none'
      stroke='currentColor'
      viewBox='0 0 24 24'
    >
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={2}
        d='M3 10h18M3 14h18M3 7h18M3 17h18'
      />
    </svg>
  )
}
